const themeColors = {
  transparent: 'transparent',
  current: 'currentColor',
  white: '#FFFFFF',
  black: '#231F20',
  blue: {
    DEFAULT: '#427EC3',
    700: '#0088C1',
    navy: {
      DEFAULT: '#1f355e',
      100: '#c6ccd6',
      200: '#8f9aaf',
      300: '#8f9aaf',
      500: '#1f355e',
      700: '#192946',
      800: '#101b2f',
      900: '#080e17'
    },
    lighthouse: {
      DEFAULT: '#82acff',
      100: '#ebf1ff',
      200: '#c7daff',
      300: '#a1c1fd',
      500: '#82acff',
      700: '#6686c7',
      800: '#4a618f',
      900: '#2d3b58'
    }
  },
  lightBlue: {
    DEFAULT: '#21B3E8',
    100: '#90D9F3',
    300: '#64CAEF',
    500: '#3B82F6',
    600: '#1EA1D0',
    650: '#228FCE',
    700: '#1A8FBA'
  },
  lighthouseBlue: {
    DEFAULT: '#82ACFF',
    100: '#C0D5FF',
    300: '#A8C5FF',
    600: '#759BE5',
    700: '#688ACC'
  },
  green: {
    DEFAULT: '#4FBC8F',
    safe: '#14B025',
    100: '#A7DDC7',
    300: '#84D0B1',
    600: '#47A980',
    700: '#3F9773'
  },
  lime: {
    DEFAULT: '#83C341',
    100: '#C1E1A0',
    300: '#A9D57A',
    600: '#76AF3A',
    700: '#699C34'
  },
  orange: {
    DEFAULT: '#FFAF47',
    warn: '#F68121',
    100: '#FFD7A3',
    200: '#FFD87D',
    300: '#FFC77F',
    600: '#E59D40',
    700: '#CC8C39'
  },
  red: {
    DEFAULT: '#DD668A',
    danger: '#D01F31',
    100: '#EEB3C4',
    300: '#E894AD',
    600: '#C75C7C',
    700: '#B1526F',
    800: '#B70000'
  },
  gray: {
    100: '#F2F3F4',
    200: '#E4E5E6',
    300: '#D1D3D4',
    400: '#D3D3D3',
    500: '#A7A9AC',
    700: '#808285',
    900: '#58595B'
  },
  grey: {
    100: '#F2F3F4',
    300: '#D1D3D4',
    500: '#A7A9AC',
    700: '#808285',
    900: '#58595B'
  },
  yellow: {
    100: '#FBDD0B'
  }
}

const themeFontFamily = {
  base: [
    'Inter Variable, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol'
  ]
}

const tailwindThemeTokens = {
  theme: {
    colors: themeColors,
    fontFamily: themeFontFamily
  }
}

export { themeColors, themeFontFamily }

export default tailwindThemeTokens
